webpackJsonp([35783957827783],{

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      { className: "TestDrive" },
	      _react2.default.createElement(
	        "div",
	        { className: "emergencybanner", hidden: true },
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "i",
	            null,
	            "***",
	            _react2.default.createElement(
	              "a",
	              { href: "https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=header&utm_medium=website&utm_content=header&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic" },
	              "Apply now"
	            ),
	            ", to find out if you are eligible to receive a free laptop and free education in any of our 101, 102, 201 and 301 courses!***"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-8 col-md-offset-2 col-md-8-explore-home-page col-md-offset-2-home-page" },
	            _react2.default.createElement(
	              "h1",
	              null,
	              "YOU + Code Fellows + AI"
	            ),
	            _react2.default.createElement(
	              "h1",
	              null,
	              "="
	            ),
	            _react2.default.createElement(
	              "h1",
	              null,
	              "A Life Changing New Career!"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "TestDrive-buttons" },
	              _react2.default.createElement(
	                "a",
	                { className: "btn btn-primary explore-btn", href: "/courses/code-101/explore-software-development/" },
	                "Explore Software Development with AI"
	              ),
	              _react2.default.createElement(
	                "a",
	                { className: "btn btn-primary explore-btn", href: "/courses/ops-101/explore-cybersecurity/" },
	                "Explore Cybersecurity with AI"
	              ),
	              _react2.default.createElement(
	                "a",
	                { className: "btn btn-primary explore-btn", href: "/courses/web3-101/explore-cryptocurrencies-and-web3-careers/" },
	                "Explore Web3 with AI"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "Stats" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "single-stat" },
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "93%"
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/employment-data/" },
	                    "In-field Job Placement"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "800+"
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/employer-partnerships/" },
	                    "Unique Hiring Companies"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "$4.7M+"
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/scholarship-fund/" },
	                    "In Scholarships Awarded "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "22"
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/powered-by-code-fellows/" },
	                    "Powered by Schools"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "StudentProfiles" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "profiles" },
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/qjy3jg1udcmq/21fjLxG3SYSYM2OOQaUEEI/123268c24d4fa0159f58b5149bd17ee3/caleb-wells.png", alt: "Caleb Wells" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"After Code Fellows, I\u2019m ready to deal with a large gamut of industry practices. We were introduced to source control (git flow) and Agile methodology, and experienced working in a development team to pair program.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Caleb Wells"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Software Development Engineer, Alaska Airlines"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/qjy3jg1udcmq/5dedhlSJHaeO8sIWYWWKuQ/231f6351820c96b3bd37c13e10b2f2c3/rae-helsel.png", alt: "Rae Helsel" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"The teachers are amazing, and the curriculum is on point and well-organized, but the best part of the program for me was the sense of community. That\u2019s everything.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Rae Helsel"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "CEO | Developer, R\u0100NA"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "mobile" },
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/k428n7s2pxlu/4eNsB8T7a0yiMwyW6a0qIu/adef6fa6c8a250719cf94d7eb940a4b4/katlyn.jpeg", alt: "Kaylyn Yuh" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"Code Fellows enables you to challenge your learning every day, and motivates you to be an impactful individual and a strong team player.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Kaylyn Yuh"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Software Developer, Bevy"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "singleProfile" },
	                _react2.default.createElement("img", { src: "https://images.ctfassets.net/k428n7s2pxlu/3iMknAabmUccEMoCsCayMc/42dcd303df167db34d0d2517bda85a37/lee.jpeg", alt: "Lee Broxson" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "\"The program\u2014especially the project weeks\u2014is focused on a pseudo-production situation. As a result, I got a good understanding of what a real-world dev job is like, and that is appealing to employers.\""
	                ),
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  "Lee Broxson"
	                ),
	                _react2.default.createElement(
	                  "h6",
	                  null,
	                  "Senior Software Engineer, Avalara"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "Financing" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-8 col-md-offset-2" },
	            _react2.default.createElement(
	              "h1",
	              null,
	              "Fund Your Future Career in Tech!"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Financing Options for Every Budget."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "financing-buttons" },
	              _react2.default.createElement(
	                "a",
	                { className: "btn btn-primary", href: "/financing-and-scholarships/#student-loans/" },
	                "Financing"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "financing-buttons" },
	              _react2.default.createElement(
	                "a",
	                { className: "btn btn-primary", href: "/scholarship-fund/" },
	                "Scholarships"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "financing-buttons" },
	              _react2.default.createElement(
	                "a",
	                { className: "btn btn-primary", href: "/gi-bill/" },
	                "GI Bill\xAE"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "Partners" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Our Grads Have Been Hired By More than ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "800"
	          ),
	          " Companies Including:"
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "Partners" },
	          _react2.default.createElement("img", { src: "https://images.ctfassets.net/k428n7s2pxlu/5M1h5WgG522soASEueSe20/aa2620c3f2f2531070db294bb424a2dc/why-hire-logo-grid.png", alt: "hiring companies" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "HomeHero" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 col-md-offset-2" },
	              _react2.default.createElement(
	                "h1",
	                null,
	                "Live Remote Instruction"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Join our classes from anywhere in the world, and interact in real-time with our team of professional industry-leading instructors."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "HomeHero-buttons" },
	                _react2.default.createElement(
	                  "a",
	                  { className: "btn btn-primary", href: "https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=homepage&utm_medium=website&utm_content=homepage&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic" },
	                  "Apply Today"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "Subheader" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 badges" },
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.coursereport.com/schools/code-fellows" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/5JIajsMTOU0NQ0cHdgiTSy/ae7648c376fe4e489abd804ac44e3c0e/Best_Coding_Bootcamps_Badge_2023_New__2_.png", alt: "Course Report" })
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.switchup.org/bootcamps/code-fellows" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/yKQMr2YJhegfMq1Kgeks3/5f2e43e7849cfca4538d6e29d433258f/su-best-coding-2022-6years.png", alt: "Switchup" })
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.coursereport.com/schools/code-fellows" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/5Orp1b7wOQqcyGwpck1PM3/9b87ad9382e02720326654ac0eb3b3d6/Best_Online_Bootcamps_Badge_2022_New__1_.png" })
	              )
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://careerkarma.com/schools/code-fellows/" },
	              _react2.default.createElement(
	                "div",
	                { className: "mega-buttons" },
	                _react2.default.createElement("img", { src: "//images.ctfassets.net/k428n7s2pxlu/1NyyNLfTMZeYAnpdrnN0Kz/499636e9a0671463b5b9f2d70c0bf5fe/Best__cyber_security_bootcamp.png", alt: "Career Karma" })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 1963:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1963);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	var _landing = __webpack_require__(297);
	
	var _landing2 = _interopRequireDefault(_landing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // SYLES
	//import './_index.scss'
	
	
	// LIBS
	
	
	// HELPERS
	var prefixLink = function prefixLink(url) {
	  return url;
	};
	
	// COMPONENTS
	
	// INTERFACE
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'wrapper' },
	      _react2.default.createElement(_metaData2.default, { data: {
	          slug: '',
	          title: 'Premier Tech Academy | Discover a Rewarding New Career | Code Fellows',
	          description: 'Code Fellows is the Pacific Northwest’s premier technical skills training academy, delivering high-quality live instruction both online and in person to people from all backgrounds.'
	        } }),
	      _react2.default.createElement(_landing2.default, null)
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	module.exports = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-cfc4130565fd92e3a842.js